export const defaultConfig = {
  KEY_TOKEN: 'AUTH_TOKEN',
  TITLE: 'Grow Uperion',
};
